module.exports = __webpack_public_path__ + "img/3.f2245c20.jpg";